import { useEffect, useRef, useState } from 'react';
import './App.css';

const navItems = [
  ['hero', 'HOME', 'home'],
  ['about', 'ABOUT', 'home'],
  ['services', 'SERVICES', 'home'],
  ['products', 'PRODUCTS', 'home'],
  ['process', 'PROCESS', 'home'],
  ['faq', 'FAQ', 'home'],
  // ['testimonials', 'TESTIMONIALS', 'home'],
  ['tech-partners', 'PARTNERS', 'home'],
  ['contact', 'CONTACT', 'home'],
  // ['team', 'TEAM', 'team'],
];

const aboutCards = [
  {
    title: 'Mission',
    text: 'Empower brands to thrive in the digital world by delivering innovative, customer-focused solutions that drive results.',
    icon: 'bi-lightning-charge-fill',
  },
  {
    title: 'Vision',
    text: 'To be a global leader in digital innovation where technology and creativity create meaningful impact.',
    icon: 'bi-eye-fill',
  },
  {
    title: 'Goals',
    text: 'Push innovation boundaries continuously while maintaining client-centricity and operational excellence.',
    icon: 'bi-bullseye',
  },
  {
    title: 'Values',
    text: 'Integrity, creativity, collaboration, and accountability form the backbone of every product we deliver.',
    icon: 'bi-heart-fill',
  },
];

const stats = [
  { value: 20, suffix: '+', label: 'Years Experienced Team', animate: true },
  { value: 4, suffix: '+', label: 'Projects Completed', animate: true },
  { value: 2, suffix: '+', label: 'Happy Clients', animate: true },
  { displayValue: '24/7', label: 'Support Available', animate: false },
];

const heroMetrics = [
  ['20+', 'Years of shared team experience'],
  ['24/7', 'Support mindset for critical systems'],
  ['Cloud + AI', 'Delivery built for modern operations'],
];

const outcomeCards = [
  {
    title: 'Launch with less friction',
    text: 'We align product, engineering, and rollout planning early so teams move from idea to implementation with less rework.',
    icon: 'bi-rocket-takeoff',
  },
  {
    title: 'Reduce operational complexity',
    text: 'From APIs to dashboards to cloud setup, we simplify the systems your teams rely on every day.',
    icon: 'bi-diagram-3',
  },
  {
    title: 'Create room to scale',
    text: 'Our delivery approach is designed for security, maintainability, and future growth instead of short-term patchwork.',
    icon: 'bi-graph-up-arrow',
  },
];

const services = [
  {
    title: 'Custom Software Development',
    tag: 'Build',
    icon: 'bi-boxes',
    description:
      'We design and build tailored software solutions aligned with your business workflows, operational goals, and long-term scalability requirements.',
  },
  {
    title: 'Web & Mobile Application Development',
    tag: 'Experience',
    icon: 'bi-phone',
    description:
      'Our team creates responsive web platforms and mobile applications with intuitive user experiences, strong performance, and reliable cross-device usability.',
  },
  {
    title: 'Cloud Infrastructure Setup',
    tag: 'Cloud',
    icon: 'bi-cloud-check',
    description:
      'We architect and deploy secure cloud environments that improve availability, streamline operations, and support future-ready application growth.',
  },
  {
    title: 'AI Tools Integration',
    tag: 'Automation',
    icon: 'bi-cpu',
    description:
      'We integrate practical AI capabilities into business systems to automate tasks, improve decision-making, and enhance productivity across teams.',
  },
  {
    title: 'Database Design & Management',
    tag: 'Data',
    icon: 'bi-database',
    description:
      'From schema design to optimization and maintenance, we build dependable database systems that support accuracy, speed, and operational continuity.',
  },
  {
    title: 'API & Integration Services',
    tag: 'Connect',
    icon: 'bi-diagram-3',
    description:
      'We connect platforms, services, and internal systems through robust APIs and integrations that enable seamless and secure data exchange.',
  },
  {
    title: 'Data Security & Compliance',
    tag: 'Secure',
    icon: 'bi-shield-lock',
    description:
      'Our solutions are developed with security-first practices, helping organizations protect data, reduce risk, and meet industry compliance expectations.',
  },
  {
    title: 'Product Implementation & Support',
    tag: 'Support',
    icon: 'bi-headset',
    description:
      'We provide structured rollout, onboarding, and ongoing support to ensure smooth adoption, stable operations, and continuous improvement after launch.',
  },
];

const products = [
  {
    name: 'RTOW Chart',
    category: 'Aviation',
    icon: 'bi-airplane-engines',
    audience: 'Built for flight operations teams',
    impact: 'Faster, more confident dispatch decisions',
    focus: ['Runway analysis', 'Takeoff performance', 'Dispatch accuracy'],
    description:
      'RTOW Chart helps flight operations teams calculate regulated takeoff weight quickly and accurately using runway, weather, and aircraft performance conditions for safer dispatch decisions.',
    image: '/images/product/RTOW-New.png',
  },
  {
    name: 'Weight & Balance Software',
    category: 'Aviation',
    icon: 'bi-airplane-engines',
    audience: 'Built for airline load planning teams',
    impact: 'Safer load control with clearer planning workflows',
    focus: ['Load planning', 'Aircraft safety', 'Operational control'],
    description:
      'Weight & Balance Software streamlines load planning with precise passenger, baggage, cargo, and fuel distribution to ensure every flight remains within operational and safety limits.',
    image: '/images/product/weight-balance.png',
  },
  // {
  //   name: 'CFP - Computerised Flight Plan',
  //   category: 'Aviation',
  //   status: 'Coming Soon',
  //   icon: 'bi-calendar2-check',
  //   audience: 'Built for dispatch and planning teams',
  //   impact: 'Structured flight planning with faster pre-flight preparation',
  //   focus: ['Flight planning', 'Fuel logic', 'Dispatch documents'],
  //   description:
  //     'CFP digitizes flight planning with structured routing, fuel calculations, operational notes, and dispatch-ready documentation to support faster, more reliable pre-flight preparation.',
  //   image: '/images/product/cfp-coming-soon.png',
  // },
  // {
  //   name: 'NECPL - Crew Management',
  //   category: 'Aviation',
  //   status: 'Coming Soon',
  //   icon: 'bi-calendar2-check',
  //   audience: 'Built for airline crew operations teams',
  //   impact: 'Structured flight planning with faster pre-flight preparation',
  //   focus: ['Flight planning', 'Fuel logic', 'Dispatch documents'],
  //   description:
  //     'NECPL - Crew Management streamlines crew rostering, leave, duty tracking, training records, licenses, travel, reports, and compliance alerts to improve crew efficiency, regulatory readiness, and crew well-being.',
  //   image: '/images/product/crew_management.png',
  // },
];

const publicAsset = (path) => `${process.env.PUBLIC_URL || ''}${path}`;

const developmentProcess = [
  {
    step: '01',
    title: 'Discovery & Requirement Analysis',
    text: 'We gather business goals, user needs, and technical constraints to define a clear development roadmap.',
    icon: 'bi-search',
  },
  {
    step: '02',
    title: 'Planning & Solution Architecture',
    text: 'Our team finalizes milestones, system architecture, and delivery phases for scalable implementation.',
    icon: 'bi-diagram-3',
  },
  {
    step: '03',
    title: 'UI/UX Design & Wireframing',
    text: 'We design intuitive user journeys, wireframes, and interfaces to ensure a smooth product experience.',
    icon: 'bi-bezier2',
  },
  {
    step: '04',
    title: 'Agile Development',
    text: 'Frontend, backend, API, and database development are executed in iterative sprints with regular demos.',
    icon: 'bi-code-slash',
  },
  {
    step: '05',
    title: 'Testing & Quality Assurance',
    text: 'Each release passes functional, performance, and security testing for reliable production readiness.',
    icon: 'bi-shield-check',
  },
  {
    step: '06',
    title: 'Deployment & Ongoing Support',
    text: 'We launch, onboard teams, and provide maintenance, optimization, and enhancement support post-release.',
    icon: 'bi-rocket-takeoff',
  },
];

const techStack = [
  { file: 'ai_1.png', label: 'AI', featured: true },
  { file: 'aws.png', label: 'AWS', featured: true },
  { file: 'azure.png', label: 'Azure', featured: true },
  { file: 'gcp.png', label: 'Google Cloud', featured: true },
  { file: 'react.png', label: 'React', featured: true },
  { file: 'power_bi_1.png', label: 'Power BI', featured: true },
  { file: 'nextjs.png', label: 'Next.js' },
  { file: 'nodejs.png', label: 'Node.js' },
  { file: 'python.png', label: 'Python' },
  { file: 'java.png', label: 'Java' },
  { file: 'php.png', label: 'PHP' },
  { file: 'sql.png', label: 'SQL' },
  { file: 'mongodb.png', label: 'MongoDB' },
  { file: 'mysql.png', label: 'MySQL' },
  { file: 'postgre.png', label: 'PostgreSQL' },
  { file: 'docker_1.png', label: 'Docker' },
  { file: 'kubernetes_1.png', label: 'Kubernetes' },
  { file: 'tableau_1.png', label: 'Tableau' },
  { file: 'git.png', label: 'Git' },
  { file: 'figma.png', label: 'Figma' },
];

const faqs = [
  {
    q: 'What services does NECPL offer?',
    a: 'We offer custom software, web apps, mobile apps, cloud engineering, API integrations, database management, and AI automation solutions.',
  },
  {
    q: 'Which industries do you serve?',
    a: 'We support aviation, automotive, healthcare, retail, logistics, finance, and enterprise teams with tailored solutions.',
  },
  {
    q: 'Can you build solutions with AI and automation?',
    a: 'Yes. We integrate AI for chat, workflows, document automation, and operational insights based on your business context.',
  },
  {
    q: 'Do you provide end-to-end project support?',
    a: 'Yes. We handle planning, development, deployment, onboarding, and long-term maintenance support.',
  },
  {
    q: 'How can I get a quote or consultation?',
    a: 'Use the contact form below or email us at info@nexteraconnect.co.in and our team will connect quickly.',
  },
];

const testimonials = [
  {
    name: 'Mr. Ravi Menon',
    // role: 'Director',
    company: 'QuickJet Airlines',
    text: 'Their industry-specific approach helped us improve efficiency and security in our aviation services.',
    focus: 'Operational clarity',
    metric: 'Improved service confidence',
  },
  {
    name: 'Ms. Rhea Sharma',
    role: 'Operations Lead',
    company: 'Enterprise Mobility Client',
    text: 'The team stayed practical, responsive, and deeply involved from planning through rollout. Delivery felt structured and dependable.',
    focus: 'Reliable rollout',
    metric: 'Smoother implementation',
  },
  {
    name: 'Mr. Arvind Kulkarni',
    role: 'Product Head',
    company: 'Digital Transformation Partner',
    text: 'They translated complex requirements into clean product decisions and kept momentum high without compromising quality.',
    focus: 'Strong product thinking',
    metric: 'Clearer product direction',
  },
];

const featuredTestimonial = testimonials[0];
const secondaryTestimonials = testimonials.slice(1);

const techPartners = [
  ['/images/tech-partner/quickjet.png', 'Quikjet Airlines'],
  // ['/images/tech-partner/vman.png', 'Vman Aero Services Pvt Ltd'],
  // ['/images/tech-partner/oneseven.png', 'One Seven Consultancy'],
  // ['/images/tech-partner/magnus.png', 'Magnus Motots'],
  // ['/images/tech-partner/tech_termeric.png', 'Tech Termeric'],
];

const heroPoints = ['Cloud-native delivery', 'AI-powered workflows', 'Enterprise-grade execution'];
const partnerSignals = ['Aviation-focused delivery', 'Private client engagements', 'Long-term implementation support'];
const contactSteps = [
  'We usually respond within one business day.',
  'The first conversation is focused on scope, timeline, and fit.',
  'We are comfortable with confidential and NDA-led discussions.',
];

const teamPrinciples = [
  {
    title: 'Practical over flashy',
    text: 'We care about what teams can run, support, and trust after launch, not just what looks impressive in a demo.',
  },
  {
    title: 'Structured collaboration',
    text: 'We keep communication clear, expectations visible, and delivery grounded in milestone-driven progress.',
  },
  {
    title: 'Built for long-term use',
    text: 'Security, maintainability, and future extensibility are part of how we build from day one.',
  },
];

const teamMembers = [
  {
    name: 'Amit Verma',
    role: 'Founder & Delivery Lead',
    image: '/images/placeholder.jpg',
    bio: 'Leads client strategy, solution direction, and delivery planning with a focus on turning complex requirements into practical execution.',
  },
  {
    name: 'Ritika Sharma',
    role: 'Product & Experience Lead',
    image: '/images/placeholder.jpg',
    bio: 'Shapes product structure, UX thinking, and implementation clarity so teams can move from workflows to working systems faster.',
  },
  {
    name: 'Karan Mehta',
    role: 'Engineering & Architecture Lead',
    image: '/images/placeholder.jpg',
    bio: 'Drives application engineering, system architecture, and integration design with an emphasis on maintainability and scale.',
  },
  {
    name: 'Neha Iyer',
    role: 'Cloud, Data & Automation Lead',
    image: '/images/placeholder.jpg',
    bio: 'Connects cloud infrastructure, reporting systems, and AI-enabled workflows to reduce manual overhead across operations.',
  },
];

const countryOptions = [
  { iso: 'AF', name: 'Afghanistan', dialCode: '+93' },
  { iso: 'AL', name: 'Albania', dialCode: '+355' },
  { iso: 'DZ', name: 'Algeria', dialCode: '+213' },
  { iso: 'AD', name: 'Andorra', dialCode: '+376' },
  { iso: 'AO', name: 'Angola', dialCode: '+244' },
  { iso: 'AG', name: 'Antigua and Barbuda', dialCode: '+1-268' },
  { iso: 'AR', name: 'Argentina', dialCode: '+54' },
  { iso: 'AM', name: 'Armenia', dialCode: '+374' },
  { iso: 'AU', name: 'Australia', dialCode: '+61' },
  { iso: 'AT', name: 'Austria', dialCode: '+43' },
  { iso: 'AZ', name: 'Azerbaijan', dialCode: '+994' },
  { iso: 'BS', name: 'Bahamas', dialCode: '+1-242' },
  { iso: 'BH', name: 'Bahrain', dialCode: '+973' },
  { iso: 'BD', name: 'Bangladesh', dialCode: '+880' },
  { iso: 'BB', name: 'Barbados', dialCode: '+1-246' },
  { iso: 'BY', name: 'Belarus', dialCode: '+375' },
  { iso: 'BE', name: 'Belgium', dialCode: '+32' },
  { iso: 'BZ', name: 'Belize', dialCode: '+501' },
  { iso: 'BJ', name: 'Benin', dialCode: '+229' },
  { iso: 'BT', name: 'Bhutan', dialCode: '+975' },
  { iso: 'BO', name: 'Bolivia', dialCode: '+591' },
  { iso: 'BA', name: 'Bosnia and Herzegovina', dialCode: '+387' },
  { iso: 'BW', name: 'Botswana', dialCode: '+267' },
  { iso: 'BR', name: 'Brazil', dialCode: '+55' },
  { iso: 'BN', name: 'Brunei', dialCode: '+673' },
  { iso: 'BG', name: 'Bulgaria', dialCode: '+359' },
  { iso: 'BF', name: 'Burkina Faso', dialCode: '+226' },
  { iso: 'BI', name: 'Burundi', dialCode: '+257' },
  { iso: 'CV', name: 'Cabo Verde', dialCode: '+238' },
  { iso: 'KH', name: 'Cambodia', dialCode: '+855' },
  { iso: 'CM', name: 'Cameroon', dialCode: '+237' },
  { iso: 'CA', name: 'Canada', dialCode: '+1' },
  { iso: 'CF', name: 'Central African Republic', dialCode: '+236' },
  { iso: 'TD', name: 'Chad', dialCode: '+235' },
  { iso: 'CL', name: 'Chile', dialCode: '+56' },
  { iso: 'CN', name: 'China', dialCode: '+86' },
  { iso: 'CO', name: 'Colombia', dialCode: '+57' },
  { iso: 'KM', name: 'Comoros', dialCode: '+269' },
  { iso: 'CG', name: 'Congo', dialCode: '+242' },
  { iso: 'CD', name: 'Congo (DRC)', dialCode: '+243' },
  { iso: 'CR', name: 'Costa Rica', dialCode: '+506' },
  { iso: 'CI', name: "Cote d'Ivoire", dialCode: '+225' },
  { iso: 'HR', name: 'Croatia', dialCode: '+385' },
  { iso: 'CU', name: 'Cuba', dialCode: '+53' },
  { iso: 'CY', name: 'Cyprus', dialCode: '+357' },
  { iso: 'CZ', name: 'Czech Republic', dialCode: '+420' },
  { iso: 'DK', name: 'Denmark', dialCode: '+45' },
  { iso: 'DJ', name: 'Djibouti', dialCode: '+253' },
  { iso: 'DM', name: 'Dominica', dialCode: '+1-767' },
  { iso: 'DO', name: 'Dominican Republic', dialCode: '+1-809' },
  { iso: 'EC', name: 'Ecuador', dialCode: '+593' },
  { iso: 'EG', name: 'Egypt', dialCode: '+20' },
  { iso: 'SV', name: 'El Salvador', dialCode: '+503' },
  { iso: 'GQ', name: 'Equatorial Guinea', dialCode: '+240' },
  { iso: 'ER', name: 'Eritrea', dialCode: '+291' },
  { iso: 'EE', name: 'Estonia', dialCode: '+372' },
  { iso: 'SZ', name: 'Eswatini', dialCode: '+268' },
  { iso: 'ET', name: 'Ethiopia', dialCode: '+251' },
  { iso: 'FJ', name: 'Fiji', dialCode: '+679' },
  { iso: 'FI', name: 'Finland', dialCode: '+358' },
  { iso: 'FR', name: 'France', dialCode: '+33' },
  { iso: 'GA', name: 'Gabon', dialCode: '+241' },
  { iso: 'GM', name: 'Gambia', dialCode: '+220' },
  { iso: 'GE', name: 'Georgia', dialCode: '+995' },
  { iso: 'DE', name: 'Germany', dialCode: '+49' },
  { iso: 'GH', name: 'Ghana', dialCode: '+233' },
  { iso: 'GR', name: 'Greece', dialCode: '+30' },
  { iso: 'GD', name: 'Grenada', dialCode: '+1-473' },
  { iso: 'GT', name: 'Guatemala', dialCode: '+502' },
  { iso: 'GN', name: 'Guinea', dialCode: '+224' },
  { iso: 'GW', name: 'Guinea-Bissau', dialCode: '+245' },
  { iso: 'GY', name: 'Guyana', dialCode: '+592' },
  { iso: 'HT', name: 'Haiti', dialCode: '+509' },
  { iso: 'HN', name: 'Honduras', dialCode: '+504' },
  { iso: 'HU', name: 'Hungary', dialCode: '+36' },
  { iso: 'IS', name: 'Iceland', dialCode: '+354' },
  { iso: 'IN', name: 'India', dialCode: '+91' },
  { iso: 'ID', name: 'Indonesia', dialCode: '+62' },
  { iso: 'IR', name: 'Iran', dialCode: '+98' },
  { iso: 'IQ', name: 'Iraq', dialCode: '+964' },
  { iso: 'IE', name: 'Ireland', dialCode: '+353' },
  { iso: 'IL', name: 'Israel', dialCode: '+972' },
  { iso: 'IT', name: 'Italy', dialCode: '+39' },
  { iso: 'JM', name: 'Jamaica', dialCode: '+1-876' },
  { iso: 'JP', name: 'Japan', dialCode: '+81' },
  { iso: 'JO', name: 'Jordan', dialCode: '+962' },
  { iso: 'KZ', name: 'Kazakhstan', dialCode: '+7' },
  { iso: 'KE', name: 'Kenya', dialCode: '+254' },
  { iso: 'KI', name: 'Kiribati', dialCode: '+686' },
  { iso: 'KW', name: 'Kuwait', dialCode: '+965' },
  { iso: 'KG', name: 'Kyrgyzstan', dialCode: '+996' },
  { iso: 'LA', name: 'Laos', dialCode: '+856' },
  { iso: 'LV', name: 'Latvia', dialCode: '+371' },
  { iso: 'LB', name: 'Lebanon', dialCode: '+961' },
  { iso: 'LS', name: 'Lesotho', dialCode: '+266' },
  { iso: 'LR', name: 'Liberia', dialCode: '+231' },
  { iso: 'LY', name: 'Libya', dialCode: '+218' },
  { iso: 'LI', name: 'Liechtenstein', dialCode: '+423' },
  { iso: 'LT', name: 'Lithuania', dialCode: '+370' },
  { iso: 'LU', name: 'Luxembourg', dialCode: '+352' },
  { iso: 'MG', name: 'Madagascar', dialCode: '+261' },
  { iso: 'MW', name: 'Malawi', dialCode: '+265' },
  { iso: 'MY', name: 'Malaysia', dialCode: '+60' },
  { iso: 'MV', name: 'Maldives', dialCode: '+960' },
  { iso: 'ML', name: 'Mali', dialCode: '+223' },
  { iso: 'MT', name: 'Malta', dialCode: '+356' },
  { iso: 'MH', name: 'Marshall Islands', dialCode: '+692' },
  { iso: 'MR', name: 'Mauritania', dialCode: '+222' },
  { iso: 'MU', name: 'Mauritius', dialCode: '+230' },
  { iso: 'MX', name: 'Mexico', dialCode: '+52' },
  { iso: 'FM', name: 'Micronesia', dialCode: '+691' },
  { iso: 'MD', name: 'Moldova', dialCode: '+373' },
  { iso: 'MC', name: 'Monaco', dialCode: '+377' },
  { iso: 'MN', name: 'Mongolia', dialCode: '+976' },
  { iso: 'ME', name: 'Montenegro', dialCode: '+382' },
  { iso: 'MA', name: 'Morocco', dialCode: '+212' },
  { iso: 'MZ', name: 'Mozambique', dialCode: '+258' },
  { iso: 'MM', name: 'Myanmar', dialCode: '+95' },
  { iso: 'NA', name: 'Namibia', dialCode: '+264' },
  { iso: 'NR', name: 'Nauru', dialCode: '+674' },
  { iso: 'NP', name: 'Nepal', dialCode: '+977' },
  { iso: 'NL', name: 'Netherlands', dialCode: '+31' },
  { iso: 'NZ', name: 'New Zealand', dialCode: '+64' },
  { iso: 'NI', name: 'Nicaragua', dialCode: '+505' },
  { iso: 'NE', name: 'Niger', dialCode: '+227' },
  { iso: 'NG', name: 'Nigeria', dialCode: '+234' },
  { iso: 'KP', name: 'North Korea', dialCode: '+850' },
  { iso: 'MK', name: 'North Macedonia', dialCode: '+389' },
  { iso: 'NO', name: 'Norway', dialCode: '+47' },
  { iso: 'OM', name: 'Oman', dialCode: '+968' },
  { iso: 'PK', name: 'Pakistan', dialCode: '+92' },
  { iso: 'PW', name: 'Palau', dialCode: '+680' },
  { iso: 'PS', name: 'Palestine', dialCode: '+970' },
  { iso: 'PA', name: 'Panama', dialCode: '+507' },
  { iso: 'PG', name: 'Papua New Guinea', dialCode: '+675' },
  { iso: 'PY', name: 'Paraguay', dialCode: '+595' },
  { iso: 'PE', name: 'Peru', dialCode: '+51' },
  { iso: 'PH', name: 'Philippines', dialCode: '+63' },
  { iso: 'PL', name: 'Poland', dialCode: '+48' },
  { iso: 'PT', name: 'Portugal', dialCode: '+351' },
  { iso: 'QA', name: 'Qatar', dialCode: '+974' },
  { iso: 'RO', name: 'Romania', dialCode: '+40' },
  { iso: 'RU', name: 'Russia', dialCode: '+7' },
  { iso: 'RW', name: 'Rwanda', dialCode: '+250' },
  { iso: 'KN', name: 'Saint Kitts and Nevis', dialCode: '+1-869' },
  { iso: 'LC', name: 'Saint Lucia', dialCode: '+1-758' },
  { iso: 'VC', name: 'Saint Vincent and the Grenadines', dialCode: '+1-784' },
  { iso: 'WS', name: 'Samoa', dialCode: '+685' },
  { iso: 'SM', name: 'San Marino', dialCode: '+378' },
  { iso: 'ST', name: 'Sao Tome and Principe', dialCode: '+239' },
  { iso: 'SA', name: 'Saudi Arabia', dialCode: '+966' },
  { iso: 'SN', name: 'Senegal', dialCode: '+221' },
  { iso: 'RS', name: 'Serbia', dialCode: '+381' },
  { iso: 'SC', name: 'Seychelles', dialCode: '+248' },
  { iso: 'SL', name: 'Sierra Leone', dialCode: '+232' },
  { iso: 'SG', name: 'Singapore', dialCode: '+65' },
  { iso: 'SK', name: 'Slovakia', dialCode: '+421' },
  { iso: 'SI', name: 'Slovenia', dialCode: '+386' },
  { iso: 'SB', name: 'Solomon Islands', dialCode: '+677' },
  { iso: 'SO', name: 'Somalia', dialCode: '+252' },
  { iso: 'ZA', name: 'South Africa', dialCode: '+27' },
  { iso: 'KR', name: 'South Korea', dialCode: '+82' },
  { iso: 'SS', name: 'South Sudan', dialCode: '+211' },
  { iso: 'ES', name: 'Spain', dialCode: '+34' },
  { iso: 'LK', name: 'Sri Lanka', dialCode: '+94' },
  { iso: 'SD', name: 'Sudan', dialCode: '+249' },
  { iso: 'SR', name: 'Suriname', dialCode: '+597' },
  { iso: 'SE', name: 'Sweden', dialCode: '+46' },
  { iso: 'CH', name: 'Switzerland', dialCode: '+41' },
  { iso: 'SY', name: 'Syria', dialCode: '+963' },
  { iso: 'TW', name: 'Taiwan', dialCode: '+886' },
  { iso: 'TJ', name: 'Tajikistan', dialCode: '+992' },
  { iso: 'TZ', name: 'Tanzania', dialCode: '+255' },
  { iso: 'TH', name: 'Thailand', dialCode: '+66' },
  { iso: 'TL', name: 'Timor-Leste', dialCode: '+670' },
  { iso: 'TG', name: 'Togo', dialCode: '+228' },
  { iso: 'TO', name: 'Tonga', dialCode: '+676' },
  { iso: 'TT', name: 'Trinidad and Tobago', dialCode: '+1-868' },
  { iso: 'TN', name: 'Tunisia', dialCode: '+216' },
  { iso: 'TR', name: 'Turkey', dialCode: '+90' },
  { iso: 'TM', name: 'Turkmenistan', dialCode: '+993' },
  { iso: 'TV', name: 'Tuvalu', dialCode: '+688' },
  { iso: 'UG', name: 'Uganda', dialCode: '+256' },
  { iso: 'UA', name: 'Ukraine', dialCode: '+380' },
  { iso: 'AE', name: 'United Arab Emirates', dialCode: '+971' },
  { iso: 'GB', name: 'United Kingdom', dialCode: '+44' },
  { iso: 'US', name: 'United States', dialCode: '+1' },
  { iso: 'UY', name: 'Uruguay', dialCode: '+598' },
  { iso: 'UZ', name: 'Uzbekistan', dialCode: '+998' },
  { iso: 'VU', name: 'Vanuatu', dialCode: '+678' },
  { iso: 'VA', name: 'Vatican City', dialCode: '+379' },
  { iso: 'VE', name: 'Venezuela', dialCode: '+58' },
  { iso: 'VN', name: 'Vietnam', dialCode: '+84' },
  { iso: 'YE', name: 'Yemen', dialCode: '+967' },
  { iso: 'ZM', name: 'Zambia', dialCode: '+260' },
  { iso: 'ZW', name: 'Zimbabwe', dialCode: '+263' },
];

const getFlagEmoji = (isoCode) =>
  isoCode.replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt(0)));

const getCurrentPath = () => (window.location.pathname === '/team' ? '/team' : '/');

const seoConfig = {
  '/': {
    title: 'Nextera Connect Pvt Ltd | Software, Cloud & AI Solutions',
    description:
      'Nextera Connect Pvt Ltd builds custom software, web and mobile apps, cloud infrastructure, AI integrations, and secure digital solutions for modern businesses.',
    canonical: 'https://nexteraconnect.co.in/',
    ogTitle: 'Nextera Connect Pvt Ltd | Software, Cloud & AI Solutions',
    ogDescription:
      'We design and build custom software, cloud, and AI-driven digital solutions that help teams operate with more clarity and scale with confidence.',
  },
  '/team': {
    title: 'Our Team | Nextera Connect Pvt Ltd',
    description:
      'Meet the Nextera Connect team behind product thinking, engineering, cloud delivery, and implementation for modern digital systems.',
    canonical: 'https://nexteraconnect.co.in/team',
    ogTitle: 'Our Team | Nextera Connect Pvt Ltd',
    ogDescription:
      'Explore the team behind Nextera Connect and see how strategy, engineering, cloud, and delivery come together in one collaborative group.',
  },
};

function App() {
  const [currentPath, setCurrentPath] = useState(getCurrentPath);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [statCounts, setStatCounts] = useState(() => stats.map(() => 0));
  const [hasStartedStats, setHasStartedStats] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [emailId, setEmailId] = useState('');
  const [selectedCountryIso, setSelectedCountryIso] = useState('IN');
  const [contactPhone, setContactPhone] = useState('');
  const [helpDetails, setHelpDetails] = useState('');
  const [attachedFile, setAttachedFile] = useState(null);
  const [attachedFileName, setAttachedFileName] = useState('');
  const [contactFormStatus, setContactFormStatus] = useState(null);
  const [isContactSubmitting, setIsContactSubmitting] = useState(false);
  const aboutStatsRef = useRef(null);
  const currentYear = new Date().getFullYear();
  const isTeamPage = currentPath === '/team';
  const selectedCountry =
    countryOptions.find((country) => country.iso === selectedCountryIso) ?? countryOptions[0];

  useEffect(() => {
    document.body.classList.remove('index-page', 'team-page');
    document.body.classList.add(isTeamPage ? 'team-page' : 'index-page');
    return () => {
      document.body.classList.remove('index-page', 'team-page');
    };
  }, [isTeamPage]);

  useEffect(() => {
    const currentSeo = seoConfig[currentPath] ?? seoConfig['/'];
    const setMeta = (selector, content) => {
      const element = document.querySelector(selector);

      if (element && content) {
        element.setAttribute('content', content);
      }
    };
    const canonicalLink = document.querySelector('link[rel="canonical"]');

    document.title = currentSeo.title;
    setMeta('meta[name="description"]', currentSeo.description);
    setMeta('meta[property="og:title"]', currentSeo.ogTitle);
    setMeta('meta[property="og:description"]', currentSeo.ogDescription);
    setMeta('meta[property="og:url"]', currentSeo.canonical);
    setMeta('meta[name="twitter:title"]', currentSeo.ogTitle);
    setMeta('meta[name="twitter:description"]', currentSeo.ogDescription);

    if (canonicalLink) {
      canonicalLink.setAttribute('href', currentSeo.canonical);
    }
  }, [currentPath]);

  useEffect(() => {
    const handlePopState = () => {
      setCurrentPath(getCurrentPath());
      setMobileOpen(false);
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  useEffect(() => {
    if (isTeamPage || hasStartedStats) {
      return undefined;
    }

    const statsSection = aboutStatsRef.current;

    if (!statsSection) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setHasStartedStats(true);
          observer.disconnect();
        }
      },
      { threshold: 0.35 }
    );

    observer.observe(statsSection);

    return () => {
      observer.disconnect();
    };
  }, [hasStartedStats, isTeamPage]);

  useEffect(() => {
    if (!hasStartedStats) {
      return undefined;
    }

    const animatedStats = stats
      .map((item, index) => ({ ...item, index }))
      .filter((item) => item.animate);

    if (animatedStats.length === 0) {
      return undefined;
    }

    const duration = 1400;
    const frameRate = 1000 / 60;
    const totalFrames = Math.round(duration / frameRate);
    let frame = 0;

    const timer = window.setInterval(() => {
      frame += 1;
      const progress = Math.min(frame / totalFrames, 1);

      setStatCounts((prev) =>
        prev.map((count, index) => {
          const stat = animatedStats.find((item) => item.index === index);

          if (!stat) {
            return count;
          }

          return Math.round(stat.value * progress);
        })
      );

      if (progress === 1) {
        window.clearInterval(timer);
      }
    }, frameRate);

    return () => {
      window.clearInterval(timer);
    };
  }, [hasStartedStats]);

  const scrollToSection = (sectionId) => {
    window.requestAnimationFrame(() => {
      const target = document.getElementById(sectionId);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  };

  const navigateTo = (path, sectionId) => {
    if (window.location.pathname !== path) {
      window.history.pushState({}, '', path);
      setCurrentPath(path);
    }

    setMobileOpen(false);

    if (sectionId) {
      window.setTimeout(() => {
        scrollToSection(sectionId);
      }, 50);
      return;
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleLogoClick = (e) => {
    if (isTeamPage) {
      e.preventDefault();
      navigateTo('/');
    } else {
      setMobileOpen(false);
    }
  };

  const handleNavClick = (e, href, type) => {
    if (type === 'team-page') {
      e.preventDefault();
      navigateTo('/team');
      return;
    }

    if (type === 'home-section') {
      if (isTeamPage) {
        e.preventDefault();
        navigateTo('/', href.replace('#', ''));
        return;
      }

      setMobileOpen(false);
      return;
    }

    if (type === 'home-contact') {
      e.preventDefault();
      navigateTo('/', 'contact');
      return;
    }

    if (isTeamPage) {
      if (href === '#contact') {
        e.preventDefault();
        navigateTo('/', 'contact');
        return;
      }

      setMobileOpen(false);
      return;
    }

    setMobileOpen(false);
  };
  const handlePhoneInput = (e) => {
    const digits = e.target.value.replace(/\D/g, '').slice(0, 15);
    setContactPhone(digits);
  };
  const handleAttachmentChange = (e) => {
    const file = e.target.files?.[0];
    setAttachedFile(file ?? null);
    setAttachedFileName(file ? file.name : '');
  };
  const handleRequestProposal = async (e) => {
    e.preventDefault();

    if (!firstName.trim() || !emailId.trim() || !contactPhone.trim()) {
      setContactFormStatus({
        type: 'error',
        message: 'Please fill in your first name, email, and contact number.',
      });
      return;
    }

    const formData = new FormData();
    formData.append('first_name', firstName.trim());
    formData.append('last_name', lastName.trim());
    formData.append('email', emailId.trim());
    formData.append('phone', `${selectedCountry.dialCode} ${contactPhone.trim()}`);
    formData.append('message', helpDetails.trim());

    if (attachedFile) {
      formData.append('attachment', attachedFile);
    }

    setIsContactSubmitting(true);
    setContactFormStatus({ type: 'info', message: 'Sending your request...' });

    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        body: formData,
      });
      const data = await response.json().catch(() => ({}));

      if (!response.ok || data.success === false) {
        throw new Error(data.message || 'Unable to submit the form right now.');
      }

      setFirstName('');
      setLastName('');
      setEmailId('');
      setSelectedCountryIso('IN');
      setContactPhone('');
      setHelpDetails('');
      setAttachedFile(null);
      setAttachedFileName('');
      e.currentTarget.reset();
      setContactFormStatus({
        type: 'success',
        message: data.message || 'Your form has been submitted successfully.',
      });
    } catch (error) {
      setContactFormStatus({
        type: 'error',
        message: error.message || 'Unable to submit the form right now. Please try again later.',
      });
    } finally {
      setIsContactSubmitting(false);
    }
  };

  return (
    <>
      <header id="header" className="header d-flex align-items-center fixed-top">
        <div className="container-fluid container-xl position-relative d-flex align-items-center">
          <a
            href={isTeamPage ? '/' : '#hero'}
            className="logo d-flex align-items-center me-auto"
            onClick={handleLogoClick}
          >
            <img src="/images/logo/necpl.png" alt="Nextera Connect Pvt Ltd logo" className="logo-image" />
          </a>

          <nav id="navmenu" className={`navmenu ${mobileOpen ? 'mobile-nav-active' : ''}`}>
            <ul>
              {navItems.map(([href, label, type]) => (
                <li key={href}>
                  <a
                    href={type === 'team' ? '/team' : isTeamPage ? `/#${href}` : `#${href}`}
                    onClick={(e) =>
                      handleNavClick(
                        e,
                        type === 'team' ? '/team' : `#${href}`,
                        type === 'team' ? 'team-page' : 'home-section'
                      )
                    }
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
            <button
              className="mobile-nav-toggle d-xl-none bi bi-list"
              type="button"
              aria-label="Toggle navigation"
              onClick={() => setMobileOpen((v) => !v)}
            />
          </nav>

          <a
            className="btn-getstarted"
            href={isTeamPage ? '/#contact' : '#contact'}
            onClick={(e) => handleNavClick(e, isTeamPage ? '/#contact' : '#contact', isTeamPage ? 'home-contact' : undefined)}
          >
            {isTeamPage ? 'Talk To Us' : 'Talk to an Expert'}
          </a>
        </div>
      </header>

      <main className="main">
        {isTeamPage ? (
          <>
            <section id="team-hero" className="section team-hero">
              <div className="container team-hero-shell">
                <div className="team-hero-copy">
                  <span className="team-kicker">Our Team</span>
                  <h1>Builders, operators, and problem-solvers behind Nextera Connect.</h1>
                  <p>
                    Our team blends product thinking, engineering depth, cloud capability, and
                    delivery discipline to help organizations move from complexity to confident
                    execution.
                  </p>
                  <div className="team-hero-actions">
                    <a href="#team-members" className="btn-get-started" onClick={(e) => handleNavClick(e, '#team-members')}>
                      Explore the Team
                    </a>
                    <a href="/#contact" className="team-secondary-link" onClick={(e) => handleNavClick(e, '/#contact', 'home-contact')}>
                      Start a Conversation
                    </a>
                  </div>
                </div>

                <div className="team-hero-visual" aria-hidden="true">
                  <article className="team-visual-card team-visual-card-support team-visual-card-top">
                    <span className="team-visual-label">Strategy</span>
                    <p>Clear thinking before execution keeps delivery aligned.</p>
                  </article>
                  <article className="team-visual-card team-visual-card-lg">
                    <span className="team-visual-label">How We Work</span>
                    <h3>Cross-functional thinking, one shared delivery mindset.</h3>
                    <p>
                      Strategy, engineering, cloud, and implementation move together so decisions
                      stay aligned from kickoff to rollout.
                    </p>
                  </article>
                  <article className="team-visual-card team-visual-card-support team-visual-card-bottom">
                    <span className="team-visual-label">Delivery</span>
                    <p>Calm communication, strong ownership, and reliable follow-through.</p>
                  </article>
                </div>
              </div>
            </section>

            <section id="team-members" className="section team-members-section">
              <div className="container">
                <div className="team-banner">
                  <div className="team-banner-copy">
                    <span className="team-kicker">Meet Our People</span>
                    <h2>The team behind the thinking, building, and delivery.</h2>
                    <p>
                      We combine product, engineering, cloud, and delivery capability into one
                      collaborative team so our clients work with people who care about the outcome,
                      not just the handoff.
                    </p>
                  </div>
                  <div className="team-banner-tags" aria-hidden="true">
                    <span>Strategy-led</span>
                    <span>Execution-focused</span>
                    <span>Human-first collaboration</span>
                  </div>
                </div>
              </div>

              <div className="container">
                <div className="row gy-4">
                  {teamMembers.map((member) => (
                    <div className="col-lg-3 col-md-6" key={member.name}>
                      <article className="team-member-card">
                        <div className="team-member-photo-wrap">
                          <img src={member.image} alt={member.name} className="team-member-photo" />
                        </div>
                        <div className="team-member-copy">
                          <h3>{member.name}</h3>
                          <span>{member.role}</span>
                          <p>{member.bio}</p>
                        </div>
                      </article>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            <section id="team-values" className="section team-values-section">
              <div className="container section-title">
                <h2>What the Team Optimizes For Every Time</h2>
                <p>
                  The way we build matters just as much as what we build, especially for systems
                  teams need to trust long-term.
                </p>
              </div>
              <div className="container team-principles-grid">
                {teamPrinciples.map((item, index) => (
                  <article className="team-principle-card" key={item.title}>
                    <span className="team-principle-count">{String(index + 1).padStart(2, '0')}</span>
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </article>
                ))}
              </div>
            </section>

            <section className="section team-cta-section">
              <div className="container team-cta-card">
                <span className="team-kicker">Work With Us</span>
                <h2>Need a team that can think, build, and stay accountable through delivery?</h2>
                <p>
                  If you&apos;re planning a new platform, improving an existing workflow, or looking
                  for a reliable implementation partner, let&apos;s talk.
                </p>
                <a href="/#contact" className="btn-get-started" onClick={(e) => handleNavClick(e, '/#contact', 'home-contact')}>
                  Reach the Contact Form
                </a>
              </div>
            </section>
          </>
        ) : (
          <>
        <section id="hero" className="hero section">
          <div className="container">
            <div className="row gy-4 align-items-center">
              <div className="col-lg-6 order-2 order-lg-1 d-flex flex-column justify-content-center">
                <span className="hero-badge">Bookings for upcoming projects are open now!</span>
                <h1>We Design &amp; Build Digital Solutions That Drive Real Results.</h1>
                <p>
                  Turning ideas into powerful digital products through modern engineering, cloud, and
                  AI-driven execution.
                </p>
                <div className="d-flex">
                  <a href="#contact" className="btn-get-started">
                    Connect With Us
                  </a>
                </div>
                <div className="hero-points" aria-hidden="true">
                  {heroPoints.map((point) => (
                    <span key={point}>{point}</span>
                  ))}
                </div>
                <div className="hero-metrics" aria-hidden="true">
                  {heroMetrics.map(([value, label]) => (
                    <article className="hero-metric" key={label}>
                      <strong>{value}</strong>
                      <span>{label}</span>
                    </article>
                  ))}
                </div>
              </div>
              <div className="col-lg-6 order-1 order-lg-2 hero-img-wrap">
                <div className="hero-stack">
                  <img
                    src="/images/hero/hero1.png"
                    alt="Nextera Connect digital product planning interface"
                    className="hero-shot hero-shot-1"
                  />
                  <img
                    src="/images/hero/hero2.png"
                    alt="Software and cloud workflow visual"
                    className="hero-shot hero-shot-2"
                  />
                  <img
                    src="/images/hero/hero3.png"
                    alt="Team collaboration and implementation dashboard visual"
                    className="hero-shot hero-shot-3"
                  />
                  <img
                    src="/images/hero/hero4.png"
                    alt="Modern business technology solutions showcase"
                    className="hero-shot hero-shot-4"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="about" className="about section light-background">
          <div className="container section-title">
            <h2>Who We Are</h2>
            <p>Empowering businesses with state-of-the-art technology solutions.</p>
          </div>

          <div className="container">
            <p className="about-center-text">
              At NECPL, we empower businesses with modern technology tailored to each
              industry. Our team delivers secure, scalable, and future-ready products.
            </p>

            <h3 className="subhead">Our Mission, Vision &amp; Values</h3>
            <div className="row gy-4">
              {aboutCards.map((item) => (
                <div className="col-lg-3 col-md-6" key={item.title}>
                  <article className="about-pill">
                    <div className="about-pill-icon">
                      <i className={`bi ${item.icon}`} />
                    </div>
                    <h4>{item.title}</h4>
                    <p>{item.text}</p>
                  </article>
                </div>
              ))}
            </div>

            <div className="row gy-4 stat-row" ref={aboutStatsRef}>
              {stats.map((stat, index) => (
                <div className="col-lg-3 col-md-6" key={stat.label}>
                  <article className="stat-card">
                    <h4>{stat.animate ? `${statCounts[index]}${stat.suffix ?? ''}` : stat.displayValue}</h4>
                    <p>{stat.label}</p>
                  </article>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="services" className="services section light-background">
          <div className="container section-title">
            <h2>What We Can Build, Improve, and Operate</h2>
            <p>
              From product engineering to cloud, AI, security, and long-term support, we help teams
              move with more clarity and less operational drag.
            </p>
          </div>

          <div className="container">
            <div className="row gy-4">
              {services.map((service) => (
                <div className="col-lg-3 col-md-6" key={service.title}>
                  <div className="service-item position-relative">
                    <div className="icon">
                      <i className={`bi ${service.icon}`} />
                    </div>
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="section outcomes-section">
          <div className="container section-title">
            <h2>Outcomes That Make Projects Easier to Move Forward</h2>
            <p>
              We focus on practical business outcomes, not just feature delivery, so your team gets
              momentum, visibility, and systems that are easier to run.
            </p>
          </div>
          <div className="container">
            <div className="row gy-4">
              {outcomeCards.map((item) => (
                <div className="col-lg-4" key={item.title}>
                  <article className="outcome-card">
                    <div className="outcome-icon">
                      <i className={`bi ${item.icon}`} />
                    </div>
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </article>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="products" className="section products-section">
          <div className="container section-title">
            <h2>Platforms Built for Real Operational Workflows</h2>
            <p>
              These products are designed around actual team workflows, helping operations move
              faster, safer, and with better decision support.
            </p>
          </div>

          <div className="container">
            <div className="products-showcase">
              {products.map((product, index) => (
                <article className="product-showcase-card service-item" key={product.name}>
                  <div className="product-showcase-copy">
                    <div className="product-meta-row">
                      <div className="product-meta-badges">
                        <span className="product-eyebrow">{product.category}</span>
                        {product.status ? (
                          <span className="product-status-badge">{product.status}</span>
                        ) : null}
                      </div>
                      <span className="product-count">{String(index + 1).padStart(2, '0')}</span>
                    </div>

                    <div className="product-brand">
                      <span className="product-brand-mark" aria-hidden="true">
                        <i className={`bi ${product.icon}`} />
                      </span>
                      <div className="product-brand-copy">
                        <h3>{product.name}</h3>
                        <div className="product-quick-meta">
                          <span>{product.audience}</span>
                          <span>{product.impact}</span>
                        </div>
                        <p>{product.description}</p>
                      </div>
                    </div>

                    <div className="product-focus-list">
                      {product.focus.map((item) => (
                        <span key={`${product.name}-${item}`}>{item}</span>
                      ))}
                    </div>
                  </div>

                  <div className="product-showcase-media">
                    <img
                      src={publicAsset(product.image)}
                      alt={product.name}
                      className="product-showcase-image"
                    />
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section id="process" className="section process-section">
          <div className="container section-title">
            <h2>How We Take Ideas from Scope to Production</h2>
            <p>
              A structured, transparent process that takes your idea from concept to deployment and
              long-term growth.
            </p>
          </div>
          <div className="container">
            <div className="row gy-4">
              {developmentProcess.map((item) => (
                <div className="col-lg-4 col-md-6" key={item.step}>
                  <article className="process-card">
                    <div className="process-head d-flex align-items-center justify-content-between">
                      <div className="process-icon">
                        <i className={`bi ${item.icon}`} />
                      </div>
                      <span className="process-step">{item.step}</span>
                    </div>
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </article>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="tech-stack" className="section tech-stack">
          <div className="container section-title">
            <span className="tech-stack-kicker">Technology Stack</span>
            <h2>Technology That Supports Reliable Delivery</h2>
            <p>
              We choose proven tools that help us build secure, maintainable, and production-ready
              systems without overcomplicating the stack.
            </p>
          </div>
          <div className="container">
            <div className="logo-grid">
              {techStack.map((item, index) => (
                <div
                  className={`logo-item${item.featured ? ' logo-item-featured' : ''}`}
                  key={item.file}
                  style={{ '--card-delay': `${index * 90}ms` }}
                >
                  <img src={`/images/tech-stack/${item.file}`} alt={item.label} />
                  <span className="logo-label">{item.label}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="faq" className="faq section light-background">
          <div className="container section-title">
            <h2>Questions Teams Ask Before We Start</h2>
            <p>Quick answers on delivery scope, support, industries, and how we usually engage.</p>
          </div>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="faq-container">
                  {faqs.map((item, i) => (
                    <details className="faq-item" key={item.q} open={i === 0}>
                      <summary aria-label={item.q}>
                        <div className="faq-question-wrap">
                          <span className="faq-number">{String(i + 1).padStart(2, '0')}</span>
                          <span className="faq-question">{item.q}</span>
                        </div>
                        <span className="faq-toggle" aria-hidden="true">
                          <i className="bi bi-plus-lg" />
                        </span>
                      </summary>
                      <div className="faq-content">
                        <p>{item.a}</p>
                      </div>
                    </details>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <section id="testimonials" className="testimonials section">
          <div className="container section-title">
            <h2>What Delivery Feels Like When Teams Work With Us</h2>
            <p>
              Beyond design and development, clients trust us for clarity, responsiveness, and the
              ability to keep complex delivery moving.
            </p>
          </div> 

          <div className="container testimonial-wrap">
            <div className="trust-strip" aria-hidden="true">
              <span>Client-first delivery</span>
              <span>Transparent communication</span>
              <span>Long-term partnership</span>
            </div> 
              
            <div className="testimonial-carousel">
              <article className="testimonial-main">
                <div className="testimonial-main-top">
                  <span className="verified-pill">
                    <i className="bi bi-patch-check-fill" />
                    Verified Client Feedback
                  </span>
                  <i className="bi bi-quote quote-mark" />
                </div>
                <p className="testimonial-main-text">&quot;{featuredTestimonial.text}&quot;</p>
                <div className="testimonial-main-person">
                  <h3>{featuredTestimonial.name}</h3>
                  <h4>{featuredTestimonial.role}</h4>
                  <span className="company-link">{featuredTestimonial.company}</span>
                </div>
                <div className="testimonial-main-bottom" aria-hidden="true">
                  <span>{featuredTestimonial.metric}</span>
                  <span>Reliable execution</span>
                  <span>Long-term impact</span>
                </div>
              </article>

              <div className="testimonial-side-stack">
                {secondaryTestimonials.map((testimonial) => (
                  <article className="testimonial-side" key={testimonial.name}>
                    <span className="side-label">{testimonial.focus}</span>
                    <p>&quot;{testimonial.text}&quot;</p>
                    <h4>{testimonial.name}</h4>
                    <em>{testimonial.metric}</em>
                    <span>
                      {testimonial.role}, {testimonial.company}
                    </span>
                  </article>
                ))}
              </div>
            </div>

            <p className="testimonial-footnote">
              Trusted by founders, directors, and product teams building long-term digital systems
              with measurable delivery outcomes.
            </p>
          </div>
        </section> */}

        <section id="tech-partners" className="section partners-section">
          <div className="container section-title">
            <h2>Trusted by Teams Building Critical Operations</h2>
            <p>
              We support both visible client programs and private delivery engagements where
              reliability matters more than noise.
            </p>
          </div>
          <div className="container">
            <div className="partner-showcase">
              <div className="partner-signals" aria-hidden="true">
                {partnerSignals.map((item) => (
                  <span key={item}>{item}</span>
                ))}
              </div>
              <div className="partner-row">
                {techPartners.map(([img, name]) => (
                  <figure className="partner-logo" key={name}>
                    <img src={img} alt={name} />
                    <figcaption>{name}</figcaption>
                  </figure>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="section cta-band">
          <div className="container text-center">
            <span className="cta-eyebrow">Ready to scale with us</span>
            <p>
              Step into the future with smart, scalable cloud and AI-driven solutions. Let&apos;s
              build intelligent, automated success together.
            </p>
            <h2>Today, it&apos;s your turn.</h2>
            <div className="cta-tags" aria-hidden="true">
              <span>Cloud Native</span>
              <span>AI Automation</span>
              <span>Secure Delivery</span>
            </div>
            <a href="#contact" className="btn-get-started">
              Start Journey with us
            </a>
          </div>
        </section>

        <section id="contact" className="contact section">
          <div className="container section-title contact-section-title">
            <h2>Let&apos;s Talk About Your Project</h2>
            <p>
              Tell us what you&apos;re building, what needs improvement, or where your team is
              getting blocked. We&apos;ll help you find the right next move.
            </p>
          </div>
          <div className="container contact-layout">
            <div className="contact-card">
              <div className="contact-left">
                <span className="contact-kicker">Let&apos;s Build Together</span>
                <h2>
                  <span>We are excited to be</span>
                  <span>a part of your next</span>
                  <span className="contact-title-gradient">big project.</span>
                </h2>
                <p>
                  Share a little about your goals and we&apos;ll come back with the right next step,
                  whether that&apos;s a discovery call, technical discussion, or implementation plan.
                </p>
                <div className="contact-highlights" aria-hidden="true">
                  <span>Fast Response</span>
                  <span>Industry-Focused Team</span>
                  <span>Secure Delivery</span>
                </div>
                <div className="contact-steps">
                  {contactSteps.map((step) => (
                    <div className="contact-step" key={step}>
                      <i className="bi bi-check2-circle" />
                      <span>{step}</span>
                    </div>
                  ))}
                </div>

                <div className="contact-list">
                  <a className="contact-list-item" href="tel:+916366555070">
                    <span className="contact-list-icon">
                      <i className="bi bi-telephone-fill" />
                    </span>
                    <span className="contact-list-copy">
                      <strong>Phone</strong>
                      <small>+91-6366555070/71</small>
                    </span>
                  </a>
                  {/* <a className="contact-list-item" href="tel:+916366555071">
                    <span className="contact-list-icon">
                      <i className="bi bi-telephone-fill" />
                    </span>
                    <span className="contact-list-copy">
                      <strong>Alternate Phone</strong>
                      <small>+91 6366555071</small>
                    </span>
                  </a> */}
                  <a className="contact-list-item" href="mailto:info@nexteraconnect.co.in">
                    <span className="contact-list-icon">
                      <i className="bi bi-envelope-fill" />
                    </span>
                    <span className="contact-list-copy">
                      <strong>Email</strong>
                      <small>info@nexteraconnect.co.in</small>
                    </span>
                  </a>
                </div>
              </div>

              <div className="contact-right">
                <form className="contact-form-modern" onSubmit={handleRequestProposal} encType="multipart/form-data">
                  <div className="contact-form-intro">
                    <span className="contact-form-kicker">Request a Consultation</span>
                    <h3>Share your requirements and we&apos;ll respond with the right next step.</h3>
                  </div>
                  <div className="contact-form-row">
                    <div className="contact-form-field">
                      <label htmlFor="firstName">
                        First Name <span>*</span>
                      </label>
                      <input
                        id="firstName"
                        type="text"
                        placeholder="Enter first name"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        required
                      />
                    </div>
                    <div className="contact-form-field">
                      <label htmlFor="lastName">Last Name</label>
                      <input
                        id="lastName"
                        type="text"
                        placeholder="Enter last name"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                      />
                    </div>
                  </div>

                  <label htmlFor="emailId">
                    Email ID <span>*</span>
                  </label>
                  <input
                    id="emailId"
                    type="email"
                    placeholder="Enter Email ID"
                    value={emailId}
                    onChange={(e) => setEmailId(e.target.value)}
                    required
                  />

                  <label htmlFor="contactNumber">
                    Contact Number <span>*</span>
                  </label>
                  <div className="phone-input-wrap">
                    <div className="country-select-wrap">
                      <div className="country-code-display" aria-hidden="true">
                        <span className="country-flag">{getFlagEmoji(selectedCountry.iso)}</span>
                        <span className="country-dial-code">{selectedCountry.dialCode}</span>
                      </div>
                      <select
                        id="countryCode"
                        name="countryCode"
                        className="country-code"
                        value={selectedCountryIso}
                        onChange={(e) => setSelectedCountryIso(e.target.value)}
                        aria-label="Select country code"
                      >
                        {countryOptions.map((country) => (
                          <option key={`${country.iso}-${country.dialCode}`} value={country.iso}>
                            {`${getFlagEmoji(country.iso)} ${country.name} (${country.dialCode})`}
                          </option>
                        ))}
                      </select>
                    </div>
                    <input
                      id="contactNumber"
                      name="contactNumber"
                      type="tel"
                      inputMode="numeric"
                      autoComplete="tel-national"
                      maxLength={15}
                      value={contactPhone}
                      onChange={handlePhoneInput}
                      placeholder={`Enter phone number for ${selectedCountry.name}`}
                      required
                    />
                  </div>

                  <label htmlFor="helpDetails">How Can We Help?</label>
                  <textarea
                    id="helpDetails"
                    rows="4"
                    placeholder="Tell us a little about your requirement"
                    value={helpDetails}
                    onChange={(e) => setHelpDetails(e.target.value)}
                  />

                  <div className="contact-form-bottom">
                    <input
                      id="projectAttachment"
                      type="file"
                      className="attachment-input"
                      onChange={handleAttachmentChange}
                      accept=".pdf,.doc,.docx,.txt,.ppt,.pptx,.xls,.xlsx"
                    />
                    <label htmlFor="projectAttachment" className="attach-link">
                      <i className="bi bi-paperclip" />
                      {attachedFileName || 'Attach your document'}
                    </label>
                    <button type="submit" disabled={isContactSubmitting}>
                      {isContactSubmitting ? 'Sending...' : 'Submit'}
                    </button>
                  </div>
                  {contactFormStatus ? (
                    <p className={`contact-form-status ${contactFormStatus.type}`} role="status" aria-live="polite">
                      {contactFormStatus.message}
                    </p>
                  ) : null}
                </form>
              </div>
            </div>
          </div>
        </section>
          </>
        )}
      </main>

      <footer id="footer" className="footer">
        <div className="container footer-top">
          <div className="row gy-4">
            <div className="col-lg-4">
              <h4>NEXTERA CONNECT PVT LTD</h4>
              <p>
                Your trusted partner in digital transformation. We deliver innovative technology
                solutions that drive business growth.
              </p>
            </div>
            <div className="col-lg-3">
              <h4>OUR OFFICE</h4>
              <p>
                CN - 622, 4th floor
                <br />
                Novel MSR Building,
                <br />
                Subbaiah Reddy Colony,
                <br />
                Marathahalli, Bengaluru,
                <br />
                Karnataka 560037.
              </p>
            </div>
            <div className='col-lg-3'>
              <h4>REACH US</h4>
              <p>
                <a href="tel:+916366555070">+91 6366555070/71</a>
              </p>
              {/* <p>
                <a href="tel:+916366555071">+91 6366555071</a>
              </p> */}
              <p>
                <a href="mailto:info@nexteraconnect.co.in">info@nexteraconnect.co.in</a>
              </p>
            </div>
            <div className="col-lg-2">
              <h4>FOLLOW</h4>
              <div className="social-links d-flex">
                <a href="https://www.linkedin.com" target="_blank" rel="noreferrer" aria-label="LinkedIn">
                  <i className="bi bi-linkedin" />
                </a>
                <a href="https://www.facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook">
                  <i className="bi bi-facebook" />
                </a>
                <a href="https://x.com" target="_blank" rel="noreferrer" aria-label="X">
                  <i className="bi bi-twitter-x" />
                </a>
                <a href="https://www.instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram">
                  <i className="bi bi-instagram" />
                </a>
              </div>
            </div>
          </div>
          <div className="copyright">© {currentYear} Nextera Connect Pvt Ltd. All rights reserved.</div>
        </div>
      </footer>

      <a
        href={isTeamPage ? '/#contact' : '#contact'}
        className="floating-call"
        aria-label="Go to contact form"
        onClick={(e) => handleNavClick(e, isTeamPage ? '/#contact' : '#contact', isTeamPage ? 'home-contact' : undefined)}
      >
        <i className="bi bi-telephone-fill" />
      </a>

      <a
        href="https://wa.me/916366555070"
        target="_blank"
        rel="noreferrer"
        className="floating-whatsapp"
        aria-label="Chat on WhatsApp"
      >
        <i className="bi bi-whatsapp" />
      </a>
    </>
  );
}

export default App;
